<script>
import { BInputGroupText } from "bootstrap-vue";

export default {
  extends: BInputGroupText
};
</script>